import { render, staticRenderFns } from "./DetectView.vue?vue&type=template&id=6b838c08&scoped=true&"
import script from "./DetectView.vue?vue&type=script&lang=js&"
export * from "./DetectView.vue?vue&type=script&lang=js&"
import style0 from "./DetectView.vue?vue&type=style&index=0&id=6b838c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b838c08",
  null
  
)

export default component.exports